import { useState, useEffect } from 'react';
import { X, Smartphone } from 'lucide-react';

const KEY = 'mboa_migration_seen_v1';
const isStandalone = () => window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);

export default function MigrationBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const fromOld = params.get('from') === 'mboawallet' || (document.referrer || '').includes('mboawallet.com');
    if (fromOld) sessionStorage.setItem('mboa_from_old', '1');
    const flagged = fromOld || sessionStorage.getItem('mboa_from_old') === '1';
    if (flagged && !localStorage.getItem(KEY)) setShow(true);
  }, []);
  if (!show) return null;
  const close = () => { localStorage.setItem(KEY, '1'); setShow(false); };
  const standalone = isStandalone();
  return (
    <div className="fixed top-0 inset-x-0 z-[60] bg-[#0D2612] text-white px-4 py-3 shadow-lg" data-testid="migration-banner">
      <div className="max-w-3xl mx-auto flex items-start gap-3">
        <Smartphone className="w-5 h-5 text-[#FFDA00] flex-shrink-0 mt-0.5" />
        <div className="text-xs leading-relaxed flex-1">
          <p className="font-semibold text-sm">MboaSend a une nouvelle adresse : <span className="text-[#FFDA00]">mboasend.com</span></p>
          {standalone
            ? <p className="text-white/85 mt-0.5">Vous utilisez l’ancienne application installée. Pour continuer sans interruption : ouvrez <b>mboasend.com</b> dans {isIOS() ? 'Safari, touchez Partager → « Sur l’écran d’accueil »' : 'Chrome, menu ⋮ → « Installer l’application »'}, puis supprimez l’ancienne icône MboaSend.</p>
            : <p className="text-white/85 mt-0.5">Mettez à jour votre favori. Vos identifiants, soldes et historiques sont inchangés — reconnectez-vous simplement une fois.</p>}
        </div>
        <button onClick={close} className="text-white/70 hover:text-white flex-shrink-0" aria-label="Fermer" data-testid="migration-banner-close"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
}
